import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api from "../../api";

export default function CaseStudyPracticeResult() {
  const { state } = useLocation();
  const nav = useNavigate();

  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(true);

  /* ================= MATH FORMAT FUNCTION ================= */
  function formatMath(text) {
    if (!text) return "";

    const superscriptMap = {
      "0": "⁰",
      "1": "¹",
      "2": "²",
      "3": "³",
      "4": "⁴",
      "5": "⁵",
      "6": "⁶",
      "7": "⁷",
      "8": "⁸",
      "9": "⁹",
      "-": "⁻"
    };

    return text.replace(/\^(-?\d+)/g, (match, power) => {
      return power
        .split("")
        .map(char => superscriptMap[char] || char)
        .join("");
    });
  }

  /* ================= LOAD RESULT ================= */
  useEffect(() => {
    if (!state?.attemptId) {
      setLoading(false);
      return;
    }

    api
      .get(`/student/case-study-practice/result/${state.attemptId}`)
      .then((res) => setResult(res.data))
      .catch(() => alert("❌ Failed to load case study result"))
      .finally(() => setLoading(false));
  }, [state]);

  /* ================= UI STATES ================= */
  if (loading) {
    return <p style={{ padding: 30 }}>⏳ Loading result...</p>;
  }

  if (!result) {
    return (
      <div style={{ padding: 30 }}>
        <p>❌ No result found.</p>
        <button onClick={() => nav("/student/study")}>
          🔙 Back to Study.
        </button>
      </div>
    );
  }

  return (
    <div style={pageStyle}>
      <div style={overlayStyle}>

        {/* LOGO */}
        <div style={{ textAlign: "center", marginBottom: 20 }}>
          <img src="/logo.png" alt="EduAt10" style={{ width: 120 }} />
        </div>

        {/* MAIN BOX */}
        <div style={boxStyle}>
          <h2 style={{ marginBottom: 10 }}>📊 Case Study Result</h2>

          <p style={{ marginBottom: 20 }}>
            <strong>Score:</strong> {result.score} <br />
            <strong>Total Questions:</strong> {result.total_questions} <br />
            <strong>Percentage:</strong> {result.percentage}%
          </p>

          <hr />

          {result.case_study_description && (
            <div style={caseStudyBox}>
              <h3>{formatMath(result.case_study_title)}</h3>

              <p style={{ whiteSpace: "pre-line", lineHeight: "1.6" }}>
                {formatMath(result.case_study_description)}
              </p>
            </div>
          )}

          {result.questions.map((q, i) => {
            const studentAns = q.student_answer
              ? q.student_answer.toUpperCase()
              : null;

            const correctAns = q.correct_answer
              ? q.correct_answer.toUpperCase()
              : null;

            const isCorrect =
              studentAns && correctAns && studentAns === correctAns;

            return (
              <div key={q.question_id} style={questionBox}>
                <p>
                  <strong>Q{i + 1}.</strong>{" "}
                  {formatMath(q.question_text)}
                </p>

                <ul style={{ marginLeft: 20 }}>
                  <li>A: {formatMath(q.options.A)}</li>
                  <li>B: {formatMath(q.options.B)}</li>
                  <li>C: {formatMath(q.options.C)}</li>
                  <li>D: {formatMath(q.options.D)}</li>
                </ul>

                <p style={{ marginTop: 10 }}>
                  <strong>Your Answer:</strong>{" "}
                  {studentAns || "Not Attempted"} <br />
                  <strong>Correct Answer:</strong>{" "}
                  {correctAns}
                </p>

                <p
                  style={{
                    color: isCorrect ? "green" : "red",
                    fontWeight: 600,
                  }}
                >
                  {isCorrect ? "✔ Correct" : "✖ Wrong"}
                </p>
              </div>
            );
          })}

          <button
            onClick={() => nav("/student/study")}
            style={backBtn}
          >
            🔙 Back to Study
          </button>
        </div>
      </div>
    </div>
  );
}

/* ================= STYLES ================= */

const pageStyle = {
  minHeight: "100vh",
  backgroundImage: "url('/eduat10-bg.png')",
  backgroundSize: "cover",
  backgroundPosition: "center",
};

const overlayStyle = {
  minHeight: "100vh",
  background: "rgba(0,0,0,0.25)",
  padding: 30,
};

const boxStyle = {
  background: "#ffffff",
  borderRadius: 16,
  padding: 30,
  maxWidth: 900,
  margin: "0 auto",
  boxShadow: "0 8px 20px rgba(0,0,0,0.15)",
};

const questionBox = {
  marginBottom: 20,
  padding: 15,
  border: "1px solid #ddd",
  borderRadius: 8,
  background: "#f8fafc",
};

const backBtn = {
  marginTop: 20,
  padding: "12px 24px",
  background: "#2563eb",
  color: "#fff",
  border: "none",
  borderRadius: 8,
  cursor: "pointer",
  fontSize: 15,
};

const caseStudyBox = {
  background: "#eef2ff",
  padding: 20,
  borderRadius: 10,
  marginTop: 20,
  marginBottom: 20,
  border: "1px solid #c7d2fe"
};